import React, { useEffect, useState } from "react";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import { Menu } from "@headlessui/react";
import { HiOutlinePlus } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { hasPermission } from "../../../utils/hasPermission";
import {
    useGetSMSLoggingMutation,
    useGetSMSLoggingTotalCountMutation,
    useSmsBalanceCheckMutation,
} from "../../../features/tenant/smsLogging/smsLoggingApi";
import { getVendorName } from "../../../utils/getVendorName";
import toast from "react-hot-toast";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import CustomExport from "../../../components/CustomExport/CustomExport";
import { useGetSmsTemplateWithLimitOffsetForTenantMutation } from "../../../features/tenant/smsTemplate/smsTemplateApi";
import { formatter } from "../../../utils/numberFormatter";
import AnimatedNumber from "../../../components/AnimatedNumber/AnimatedNumber";

let inputClass =
    "block w-full pl-2 pr-3 border border-gray-300 rounded-lg bg-white text-sm placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors";

let intFormatter = new Intl.NumberFormat("en-IN", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

function objectsAreEqual(obj1, obj2) {
    console.log("ob1", obj1);
    console.log("ob2", obj2);
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (!obj2.hasOwnProperty(key)) {
            return false;
        }
        if (obj1[key] !== obj2[key]) {
            return false;
        }
    }
    return true;
}

const LoggingWhatsappAndSMS = () => {
    const navigate = useNavigate();

    let hasViewPermission = true;

    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationResetToggle, setPaginationResetToggle] = useState(false);
    const [total, setTotal] = useState(0);
    const currentDate = new Date().toISOString().split("T")[0];
    const [myList, setMyList] = useState([]);
    const [totalCredits, setTotalCredits] = useState(0);
    const [totatRows, setTotalRows] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const initialFilters = {
        receiver_mobile_numbers: "",
        startDate: "",
        endDate: "",
        limit: 10,
        offset: 0,
        template_id: "",
        response_success: true,
    };

    const initialFiltersForCount = {
        receiver_mobile_numbers: "",
        startDate: "",
        endDate: "",
        response_success: true,
    };
    const [request, setRequest] = useState(initialFilters);
    const [requestForCount, setRequestForCount] = useState(
        initialFiltersForCount
    );

    const [
        smsBalanceCheck,
        {
            data: smsBalanceCheckData,
            isLoading: smsBalanceCheckIsLoading,
            isError: smsBalanceCheckIsError,
            error: smsBalanceCheckError,
        },
    ] = useSmsBalanceCheckMutation();
    const [
        getSMSLogging,
        {
            data: getSMSLoggingData,
            isLoading: getSMSLoggingIsLoading,
            isError: getSMSLoggingIsError,
            error: getSMSLoggingError,
        },
    ] = useGetSMSLoggingMutation();

    const [
        getSMSLoggingTotalCount,
        {
            data: getSMSLoggingTotalCountData,
            isLoading: getSMSLoggingTotalCountIsLoading,
            isError: getSMSLoggingTotalCountIsError,
            error: getSMSLoggingTotalCountError,
        },
    ] = useGetSMSLoggingTotalCountMutation();

    const [
        getSMSLoggingCsv,
        {
            data: getSMSLogginCsvData,
            isLoading: getSMSLoggingCsvIsLoading,
            isError: getSMSLoggingCsvIsError,
            error: getSMSLoggingCsvError,
        },
    ] = useGetSMSLoggingMutation();

    const [csvData, setCsvData] = useState(null);

    const handleSMSBalanceCheck = () => {
        smsBalanceCheck({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
        });
    };

    const handleFetchSMSLogging = async (body = {}) => {
        toast.loading("Please wait");

        await getSMSLogging({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            body: body,
        });

        toast.dismiss();
    };

    const handleFetchSMSLoggingForCsv = () => {
        const newRequest = { ...request };
        newRequest["limit"] = null;
        newRequest["offset"] = null;

        getSMSLoggingCsv({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            body: newRequest,
        });
    };

    useEffect(() => {
        if (getSMSLogginCsvData) {
            toast.dismiss();
            // toast.success(getSMSLogginCsvData.message, {
            //   id: "getSMSLogginCsvData",
            // });
            setCsvData(
                getSMSLogginCsvData &&
                    getSMSLogginCsvData.body &&
                    getSMSLogginCsvData.body.records
                    ? getSMSLogginCsvData.body.records
                    : []
            );
        }
        if (getSMSLoggingCsvError) {
            toast.dismiss();
            toast.error(getSMSLoggingCsvError.data.message, {
                id: "getSMSLoggingCsvError",
            });
        }
    }, [getSMSLogginCsvData, getSMSLoggingCsvError]);

    useEffect(() => {
        if (!hasViewPermission) {
            navigate(`/genefied/${getVendorName()}/`);
        }
        console.log("First userEffect");
        getSMSLoggingTotalCount({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            body: requestForCount,
        });
    }, [requestForCount]);

    useEffect(() => {
        if (getSMSLoggingTotalCountData) {
            console.log(getSMSLoggingTotalCountData);
            setTotalRows(
                getSMSLoggingTotalCountData &&
                    getSMSLoggingTotalCountData?.body?.total
                    ? getSMSLoggingTotalCountData?.body?.total
                    : 0
            );
        }
        if (getSMSLoggingTotalCountError) {
        }
    }, [getSMSLoggingTotalCountData, getSMSLoggingTotalCountError]);

    useEffect(() => {
        if (getSMSLoggingData) {
            toast.dismiss();

            setMyList(
                getSMSLoggingData &&
                    getSMSLoggingData.body &&
                    getSMSLoggingData.body.records
                    ? getSMSLoggingData.body.records
                    : []
            );

            if (getSMSLoggingData?.body?.total_credit) {
                setTotalCredits(getSMSLoggingData?.body?.total_credit);
            }
        }
        if (getSMSLoggingError) {
            toast.dismiss();
            toast.error(getSMSLoggingError.data.message, {
                id: "getSMSLoggingError",
            });
        }
    }, [getSMSLoggingData, getSMSLoggingError]);

    const [
        getTemplateTypes,
        { isLoading: templatesLoading, data: templatesData },
    ] = useGetSmsTemplateWithLimitOffsetForTenantMutation();

    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => offset + Number(idx + 1),
            sortable: true,
            width: "80px",
        },
        {
            name: "Template Type",
            cell: (row) => row.template_type,
            sortable: true,
            width: "180px",
        },
        {
            name: "Template Text",
            cell: (row) => row.template_text,
            sortable: true,
        },
        {
            name: "SMS Response",
            cell: (row) => row.sms_response,
            sortable: true,
        },
        {
            name: "Recievers",
            cell: (row) => (
                <span>{row.receiver_mobile_numbers.map((each) => each)}</span>
            ),
            sortable: true,
        },
        {
            name: "Credit",
            cell: (row) => (row.credit ? Number(row.credit)?.toFixed(2) : "--"),
            sortable: true,
            width: "100px",
        },

        // {
        //   name: "Send By Name",
        //   cell: (row) => row.send_by_name,
        //   sortable: true,
        // },
        // {
        //   name: "Send At ",
        //   cell: (row) => new Date(row.send_at).toLocaleString(),
        //   sortable: true,
        // },
        {
            name: "Created At",
            cell: (row) => new Date(row.created_at).toLocaleString(),
            sortable: true,
        },
    ];

    const handleSearchFilter = (updatedRequest) => {
        handleFetchSMSLogging(updatedRequest);

        let tempRequest = { ...updatedRequest };
        delete tempRequest.limit;
        delete tempRequest.offset;

        if (!objectsAreEqual(tempRequest, requestForCount)) {
            setRequestForCount(tempRequest);
        }
    };

    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        console.log("new offset: ", pageNumber, newOffset, limit);
        setOffset(newOffset);
        setCurrentPage(pageNumber);
        let updatedRequest = { ...request, offset: newOffset };
        setRequest(updatedRequest);

        handleSearchFilter(updatedRequest);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setOffset(0);
        setCurrentPage(1);
        setPaginationResetToggle((prev) => !prev);
        console.log("handlePerRowsChange: ", page);
        let updatedRequest = { ...request, limit: newPerPage };

        setRequest(updatedRequest);

        handleSearchFilter(updatedRequest);
    };

    useEffect(() => {
        if (!hasViewPermission) {
            navigate(`/genefied/${getVendorName()}/`);
        }

        handleSMSBalanceCheck();

        handleSearchFilter(request);

        getTemplateTypes({
            limit: 9999,
            offset: 0,
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
        });
    }, []);

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full ">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        SMS Logging
                        <LinksComponent />
                    </div>

                    <div className="p-3">
                        <div className="mb-3">
                            <CustomExport
                                fetchData={handleFetchSMSLoggingForCsv}
                                data={csvData}
                                defaultColumnExport={[
                                    "entity_id",
                                    "template_type",
                                    "template_text",
                                    "receiver_mobile_numbers",
                                    "response_message",
                                    "created_at",
                                ]}
                                filename="smslogs"
                            />
                        </div>

                        <div className="p-3 w-full bg-white shadow rounded-lg">
                            <form
                                className="flex flex-row gap-4 w-full items-end justify-center p-2"
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    handleSearchFilter(request);
                                }}
                            >
                                <div className="space-y-2 w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Response Status
                                    </label>

                                    <select
                                        type="text"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="Template Type"
                                        value={request.response_success}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    response_success:
                                                        newValue === "true"
                                                            ? true
                                                            : newValue ===
                                                              "false"
                                                            ? false
                                                            : "",
                                                };
                                            });
                                        }}
                                    >
                                        <option value="">All Status</option>
                                        <option value={true}>Success</option>
                                        <option value={false}>
                                            Fail / Error
                                        </option>
                                    </select>
                                </div>

                                <div className="space-y-2 w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Template Type
                                    </label>

                                    <select
                                        type="text"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="Template Type"
                                        value={request.template_id}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    template_id: newValue,
                                                };
                                            });
                                        }}
                                    >
                                        <option value="">All Types</option>
                                        {templatesData?.body?.data?.map(
                                            (item, index) => (
                                                <option
                                                    key={index}
                                                    value={item?.template_id}
                                                >
                                                    {item?.type}
                                                </option>
                                            )
                                        )}
                                    </select>
                                </div>

                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Mobile
                                    </label>
                                    <input
                                        type="text"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="Mobile ..."
                                        value={request.receiver_mobile_numbers}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    receiver_mobile_numbers:
                                                        newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Start Date
                                    </label>
                                    <input
                                        type="date"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="Start Date ..."
                                        value={request.startDate}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    startDate: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        End Date
                                    </label>
                                    <input
                                        type="date"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="End Date ..."
                                        value={request.endDate}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    endDate: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="relative searchin">
                                    <button
                                        className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
                                        type="submit"
                                    >
                                        <svg
                                            className="w-4 h-4"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                            />
                                        </svg>
                                        Search
                                    </button>
                                </div>
                            </form>

                            <div className="w-full p-2 pb-4">
                                <div className="flex flex-row gap-4 items-stretch justify-center w-full">
                                    <div className="w-full bg-gradient-to-r from-purple-50 to-purple-100 rounded-lg p-4 border border-purple-200">
                                        <div className="flex items-center w-full h-full justify-start gap-3">
                                            <div className="p-1 bg-purple-500 rounded-lg">
                                                <svg
                                                    className="w-7 h-7 text-purple-100"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth={2}
                                                        d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
                                                    />
                                                </svg>
                                            </div>
                                            <div>
                                                <p className="text-lg font-bold text-purple-800">
                                                    Balance Remaining
                                                </p>

                                                <div className="text-2xl font-bold text-purple-600">
                                                    <AnimatedNumber
                                                        value={
                                                            smsBalanceCheckData
                                                                ?.body
                                                                ?.balance || 0
                                                        }
                                                        formatter={
                                                            formatter.format
                                                        }
                                                        className="inline"
                                                        duration={1}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-full bg-gradient-to-r from-red-50 to-red-100 rounded-lg p-4 border border-red-200">
                                        <div className="flex items-center w-full h-full justify-start gap-3">
                                            <div className="p-2 bg-yellow-400 rounded-lg">
                                                <svg
                                                    className="w-6 h-6 text-yellow-800"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="800px"
                                                    height="800px"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        d="M2 8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5H7"
                                                        stroke="currentColor"
                                                        stroke-width="1.5"
                                                        stroke-miterlimit="10"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
                                                        stroke="currentColor"
                                                        stroke-width="1.5"
                                                        stroke-miterlimit="10"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M2 16.5H8"
                                                        stroke="currentColor"
                                                        stroke-width="1.5"
                                                        stroke-miterlimit="10"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M2 12.5H5"
                                                        stroke="currentColor"
                                                        stroke-width="1.5"
                                                        stroke-miterlimit="10"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </svg>
                                            </div>

                                            <div>
                                                <p className="text-lg font-bold text-red-800">
                                                    Total SMS Sent
                                                </p>

                                                <AnimatedNumber
                                                    value={
                                                        getSMSLoggingTotalCountData
                                                            ?.body?.total || 0
                                                    }
                                                    formatter={
                                                        intFormatter.format
                                                    }
                                                    // formatter={formatter.format}
                                                    className="text-2xl font-bold text-red-600"
                                                    duration={1}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="w-full bg-gradient-to-r from-green-50 to-green-100 rounded-lg p-4 border border-green-200">
                                        <div className="flex items-center w-full h-full justify-start gap-3">
                                            <div className="p-2 bg-green-500 rounded-lg">
                                                <svg
                                                    className="w-7 h-7 text-green-800"
                                                    fill="currentColor"
                                                    stroke="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 32 32"
                                                >
                                                    <path d="M27.05 7H5a3 3 0 0 0-3 3v3a1 1 0 0 0 1 1h22a1 1 0 0 0 0-2H4v-2a1 1 0 0 1 1-1h22.1a1 1 0 0 1 .9 1v12.1a1 1 0 0 1-.95.95H5a1 1 0 0 1-1-.95V17a1 1 0 0 0-2 0v5.05A3 3 0 0 0 5 25h22.1a3 3 0 0 0 2.9-2.95V10a3 3 0 0 0-2.95-3z" />
                                                    <path d="M10 21a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2z" />
                                                </svg>
                                            </div>

                                            <div>
                                                <p className="text-lg font-bold text-green-800">
                                                    Credits used
                                                </p>

                                                <p className="text-xs font-xs text-green-700">
                                                    {/* Effective from 31st October
                                                    2025 */}
                                                    Effective from 1st November
                                                    2025
                                                </p>

                                                <div className="text-2xl font-bold text-green-600">
                                                    <AnimatedNumber
                                                        value={totalCredits}
                                                        formatter={
                                                            formatter.format
                                                        }
                                                        className="inline"
                                                        duration={1}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="flex space-x-2 justify-between">
                                    <div className="w-full relative searchin flex flex-wrap gap-2">
                                        {request.response_success == true ? (
                                            <button
                                                onClick={() => {
                                                    setRequest((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            response_success: false,
                                                        };
                                                    });
                                                }}
                                                className="flex justify-center items-center rounded bg-green-900 px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-green-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-green-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-green-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
                                            >
                                                Success
                                            </button>
                                        ) : (
                                            <button
                                                onClick={() => {
                                                    setRequest((prevState) => {
                                                        return {
                                                            ...prevState,
                                                            response_success: true,
                                                        };
                                                    });
                                                }}
                                                className="flex justify-center items-center rounded bg-danger px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#dc4c64] transition duration-150 ease-in-out hover:bg-danger-600 hover:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] focus:bg-danger-600 focus:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] focus:outline-none focus:ring-0 active:bg-danger-700 active:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(220,76,100,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)]"
                                            >
                                                Error
                                            </button>
                                        )}

                                        <button className="flex justify-center items-center rounded bg-yellow-500 px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#dc4c64] transition duration-150 ease-in-out hover:bg-danger-600 hover:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] focus:bg-danger-600 focus:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] focus:outline-none focus:ring-0 active:bg-danger-700 active:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.3),0_4px_18px_0_rgba(220,76,100,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(220,76,100,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(220,76,100,0.2),0_4px_18px_0_rgba(220,76,100,0.1)]">
                                            total :{" "}
                                            {getSMSLoggingTotalCountData &&
                                                getSMSLoggingTotalCountData
                                                    ?.body?.total}
                                        </button>

                                        <button
                                            onClick={() => {
                                                setOpenModal(true);
                                                handleSMSBalanceCheck();
                                            }}
                                            className="flex justify-center items-center rounded bg-green-900 px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-green-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-green-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-green-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
                                        >
                                            View Balance
                                        </button>

                                        <button className="flex justify-center items-center rounded bg-purple-900 px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-purple-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-purple-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-purple-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]">
                                            Credit:
                                            {totalCredits}
                                        </button>
                                    </div>
                                </div> */}
                            </div>

                            <h4 className="pt-3 flex flex-row items-center gap-1 text-2xl font-medium pl-2 text-gray-700">
                                <svg
                                    className="w-5 h-5 text-gray-600"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                    />
                                </svg>
                                Records
                            </h4>

                            <DataTableComponent
                                keyField={(row) => row.SNo}
                                columns={columns}
                                data={myList}
                                // loading={loading}
                                totalRows={totatRows}
                                handlePerRowsChange={handlePerRowsChange}
                                handlePageChange={handlePageChange}
                                paginationDefaultPage={currentPage}
                                paginationResetDefaultPage={paginationResetToggle}
                            >
                                <div className="flex m-2 space-x-2 justify-end"></div>
                            </DataTableComponent>

                            {openModal && (
                                <ModalComponent
                                    show={openModal}
                                    setShow={setOpenModal}
                                >
                                    <div className="px-3 py-3 flex w-full justify-between align-center border-b pb-2 border-gray-100">
                                        <h2 className="modal-title font-weight-bold text-lg">
                                            Balance :{" "}
                                            {smsBalanceCheckData &&
                                                smsBalanceCheckData.body &&
                                                smsBalanceCheckData.body
                                                    .balance}
                                        </h2>
                                    </div>
                                </ModalComponent>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LoggingWhatsappAndSMS;
